module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-52c727b500f44d39528827e80ba88ec1.webp";